/**
 *
 * 循环使用setTimeout 调用 fn
 *
 * @param {*} fn
 * @param {*} LoopOption  {
    interval: number;
    immediate?: boolean;
};
 * @return
 */

export function loop(
    fn,
    { interval, immediate = true } = {},
) {
    let thread = null;
    let run = () => {};

    const clear = () => {
        clearTimeout(thread);
    };

    const nextTime = () => {
        clear();
        thread = setTimeout(run, interval);
    };

    run = () => {
        fn();
        nextTime();
    };

    if (immediate) {
        run();
    } else {
        nextTime();
    }

    return clear;
}
